import { h, resolveComponent } from "vue";
import { createRouter, createWebHistory } from "vue-router";
import { ActiveUser } from "@/services/user";
import { IS_MZ_BRANDING } from "@/constants/config";
import ActivitesAnnexes from "./views/client_area/infos-pratiques/activites-annexes.vue";

// Containers
const TheContainer = () => import("@/containers/TheContainer");
const AccountContainer = () => import("@/containers/AccountContainer");

// Views
// const Dashboard = () => import("@/views/Dashboard");
const Index = () => import("@/views/Index");

// Views - Pages
const Page404 = () => import("@/views/pages/Page404");
const Page403 = () => import("@/views/pages/Page403");
const Login = () => import("@/views/pages/Login");
const Register = () => import("@/views/pages/Register");
const VerifyEmail = () => import("@/views/pages/VerifyEmail");
const ForgotPassword = () => import("@/views/pages/ForgotPassword");
const ResetPassword = () => import("@/views/pages/ResetPassword");

// Users
const Users = () => import("@/views/users/UsersView");
const User = () => import("@/views/users/UserView");

//Team
const Team = () => import("@/views/team/presentation");

//Services
const Services = () => import("@/views/prestations/prestations");

const Company = () => import("@/views/company/Company");

const Toolkit = () => import("@/views/toolkit/Toolkit");

//Prospect Open Area

const ClientOpenArea = () => import("@/views/open_client_area/Index");

const Meeting = () => import("@/views/calendar/Rdv");

const LdmRequest = () => import("@/views/open_client_area/LdmRequest");
const LdmDetail = () => import("@/views/lawyer_area/LdmDetail");

//Client Area

const ClientAreaIndex = () => import("@/views/client_area/Index");
const InfosPratiques = () => import("@/views/client_area/InfosPratiques");
const Immat = () => import("@/views/client_area/Immat");

// ||||------ Infos pratiques

const InfoActivites = () =>
  import("@/views/client_area/infos-pratiques/activites-annexes.vue");
const InfoAlcool = () =>
  import("@/views/client_area/infos-pratiques/alcool.vue");
const InfoCG = () =>
  import("@/views/client_area/infos-pratiques/carte-grise.vue");
const InfoCreation = () =>
  import("@/views/client_area/infos-pratiques/creation.vue");
const InfoFDJ = () => import("@/views/client_area/infos-pratiques/fdj.vue");
const InfoGaragiste = () =>
  import("@/views/client_area/infos-pratiques/garagiste.vue");
const InfoGaz = () => import("@/views/client_area/infos-pratiques/gaz.vue");
const InfoPresse = () =>
  import("@/views/client_area/infos-pratiques/presse.vue");
const InfoTabac = () => import("@/views/client_area/infos-pratiques/tabac.vue");

//Exploitants

const Exploitants = () => import("@/views/lawyer_area/ExploitantsList");
const Exploitant = () => import("@/views/lawyer_area/Exploitant");

///

const router = createRouter({
  history: createWebHistory(),
  linkActiveClass: "is-active",
  routes: configRoutes(),
});

// console.log(ActiveUser.get());

const isOpenAccess = (route) =>
  route.matched.some((route) => route.meta?.isOpenAccess);

const requiresAdmin = (route) =>
  route.matched.some((route) => route.meta?.requiresAdmin);

const isFound = (route) => route.matched[0].name !== "NotFound";

const isUserAdmin = (user) => {
  if (!user || !user.roles) return false;
  return user.roles.includes("superuser");
};

router.beforeEach((to, from, next) => {
  if (to.meta?.getTitle) to.meta.title = to.meta.getTitle(to);
  const user = ActiveUser.get();
  const isAuthenticated = !!user;

  if (isOpenAccess(to)) {
    return next();
  }

  if (!isAuthenticated) {
    if (isFound(to)) {
      localStorage.setItem("pathToLoadAfterLogin", to.path);
    }
    return next({ name: "Login" });
  }

  if (requiresAdmin(to) && !isUserAdmin(user)) {
    return next({ name: "Index" });
  }

  return next();
});
export default router;

function configRoutes() {
  return [
    {
      path: "/",
      redirect: "/index",
      name: "Home",
      component: TheContainer,
      children: [
        {
          path: "index",
          meta: {
            isOpenAccess: true,
          },
          name: "Index",
          component: Index,
        },
        {
          path: "team",
          meta: {
            isOpenAccess: false,
          },
          name: "Team",
          component: Team,
        },
        {
          path: "prestations",
          meta: {
            isOpenAccess: false,
          },
          name: "Prestations",
          component: Services,
        },
        {
          path: "toolkit",
          meta: {
            isOpenAccess: false,
          },
          name: "Toolkit",
          component: Toolkit,
        },
        // {
        //   path: "client-area",
        //   meta: {
        //     isOpenAccess: false,
        //   },
        //   name: "ClientArea",
        //   component: ClientAreaIndex,
        //   redirect: { name: "InfosPratiques" },
        //   children: [
        //     {
        //       path: "infos-pratiques",
        //       meta: {
        //         isOpenAccess: false,
        //       },
        //       name: "InfosPratiques",
        //       component: InfosPratiques,
        //       redirect: { name: "InfosPratiquesCreation" },
        //       children: [
        //         {
        //           path: "activites-annexes",
        //           name: "InfosPratiquesActivitesAnnexes",
        //           component: InfoActivites,
        //         },
        //         {
        //           path: "alcool",
        //           name: "InfosPratiquesAlcool",
        //           component: InfoAlcool,
        //         },
        //         {
        //           path: "carte-grise",
        //           name: "InfosPratiquesCarteGrise",
        //           component: InfoCG,
        //         },
        //         {
        //           path: "creation",
        //           name: "InfosPratiquesCreation",
        //           component: InfoCreation,
        //         },
        //         { path: "fdj", name: "InfosPratiquesFdj", component: InfoFDJ },
        //         {
        //           path: "garagiste",
        //           name: "InfosPratiquesGaragiste",
        //           component: InfoGaragiste,
        //         },
        //         { path: "gaz", name: "InfosPratiquesGaz", component: InfoGaz },
        //         {
        //           path: "presse",
        //           name: "InfosPratiquesPresse",
        //           component: InfoPresse,
        //         },
        //         {
        //           path: "tabac",
        //           name: "InfosPratiquesTabac",
        //           component: InfoTabac,
        //         },
        //       ],
        //     },
        //     {
        //       path: "immat-form",
        //       meta: {
        //         isOpenAccess: false,
        //       },
        //       name: "Immat",
        //       component: Immat,
        //     },
        //   ],
        // },
        {
          path: "contact",
          meta: {
            isOpenAccess: false,
          },
          name: "Contact",
          component: ClientOpenArea,
          redirect: "/contact/rdv",
          children: [
            {
              path: "rdv",
              meta: {
                isOpenAccess: false,
              },
              name: "RDV",
              component: Meeting,
            },
            // {
            //   path: "ldm-request",
            //   meta: {
            //     isOpenAccess: false,
            //   },
            //   name: "LdmRequest",
            //   component: LdmRequest,
            // },
          ],
        },
        // {
        //   path: "ldm-requests",
        //   meta: {
        //     isOpenAccess: false,
        //   },
        //   name: "LdmList",
        //   component: LdmRequestsList,
        // },
        {
          path: "ldm/:id",
          meta: {
            isOpenAccess: false,
          },
          name: "LdmDetail",
          component: LdmDetail,
        },
        // {
        //   path: "rdv",
        //   meta: {
        //     isOpenAccess: false,
        //   },
        //   name: "RDV",
        //   component: Meeting,
        // },
        {
          path: "company",
          meta: {
            isOpenAccess: false,
          },
          name: "Forvis Mazars",
          component: Company,
        },
        {
          path: "exploitants",
          meta: {
            isOpenAccess: false,
          },
          name: "Exploitants",
          component: Exploitants,
        },
        {
          path: "exploitant/:id",
          meta: {
            isOpenAccess: false,
          },
          name: "Exploitant",
          component: Exploitant,
        },
        {
          path: "users",
          name: "Users",
          component: Users,
          meta: {
            isOpenAccess: false,
            requiresAdmin: true,
          },
        },
        {
          path: "user/:id",
          name: "User",
          component: User,
          meta: {
            requiresAuth: true,
            requiresAdmin: true,
          },
        },
      ],
    },
    {
      path: "/oauth",
      meta: {
        isOpenAccess: true,
      },
      component: AccountContainer,
      children: [
        {
          path: "",
          name: "OAuth Login",
          component: Login,
        },
      ],
    },
    {
      path: "/account",
      name: "account",
      meta: {
        isOpenAccess: true,
      },
      component: AccountContainer,
      children: [
        {
          path: "login",
          name: "Login",
          component: Login,
        },
        {
          path: "register",
          name: "Register",
          component: Register,
        },
        {
          path: "forgot",
          name: "Forgot password",
          component: ForgotPassword,
        },
        {
          path: "reset/:token",
          name: "Password reset",
          component: ResetPassword,
        },
        {
          path: "login_management",
          name: "Management Login",
          component: Login,
          props: {
            show_email_login: true,
          },
        },
      ],
    },
    {
      path: "/verify-email",
      name: "VerifyEmail",
      component: VerifyEmail,
      meta: {
        isOpenAccess: true,
      },
    },
    {
      path: "/pages",
      redirect: "/pages/404",
      name: "Pages",
      component: {
        render() {
          return h(resolveComponent("router-view"));
        },
      },
      children: [
        {
          path: "404",
          name: "Page404",
          component: Page404,
        },
        {
          path: "403",
          name: "Page403",
          component: Page403,
        },
      ],
    },
    {
      path: "/:pathMatch(.*)*",
      component: TheContainer,
      children: [
        {
          path: "",
          name: "NotFound",
          component: Page404,
        },
      ],
    },
  ];
}
